import { Box } from '@mui/material'

/**
 * s60 -- desenho da VIGA, o mascote da IA STRONGERH (marca v1.5.1, kit v1.1 da Fabrica da Marca, 18/10/2026).
 *
 * Os SVGs sao COPIA do kit (`brand/svg/viga/`), servidos de `public/brand/viga/` -- nao se editam aqui.
 * Sempre DECORATIVO na tela: `alt=""` e `aria-hidden` -- quem le e o texto ao lado ("Sugerir com a IA STRONGERH",
 * "VIGA · IA STRONGERH", "Pensando nas sugestoes..."). Regras do kit: icone >= 16 px, selo >= 48 px, nada em loop.
 */
export function VigaIcon({ src, size, testId }: { src: string; size: number; testId?: string }) {
  return (
    <Box
      component="img"
      src={src}
      alt=""
      aria-hidden="true"
      width={size}
      height={size}
      data-testid={testId}
      sx={{ display: 'block', flexShrink: 0, width: size, height: size }}
    />
  )
}
